/*jshint browserify: true */
'use strict';

var BoxDrawMode = require('./BoxDrawMode.js');

/**
 * @name AddTextMode
 *
 * User can add a text-box on the PDF.
 */
var AddTextMode = (function AddTextModeClosure() {
    function AddTextMode(pdfElements, selectedPdfElements, pages) {
        BoxDrawMode.call(this, pdfElements, selectedPdfElements, pages);

        this.cursor = 'crosshair';

        this.defaultFont = {
            fontSize: 10,
            fontName: 'Arial',
            fontColour: '#000000',
            fontBold: false,
            fontItalic: false
        };
    }

    AddTextMode.colourSettings = {
        borderColour: '#ff0000',
        borderAlpha: 1,
        borderWidth: 2,
        fillColour: '#c0c0c0',
        fillAlpha: 0.8
    };

    AddTextMode.prototype = Object.create(BoxDrawMode.prototype);
    AddTextMode.prototype.constructor = AddTextMode;

    AddTextMode.prototype.onMouseUp = function (mouseEvent, page) {
        if (mouseEvent.button === 0 && this._mouseIsDown === true && this._mouseStartPage === page) {
            this._mouseIsDown = false;
            this._mouseEnd = coordinates.Position.fromMouseEvent(mouseEvent, page.pageViewport, page.pdfOverlayCanvasElement);

            if (this._mouseStart.pdfX !== this._mouseEnd.pdfY && this._mouseStart.pdfY !== this._mouseEnd.pdfY) {
                var newElement = new PdfTextElement();
                newElement.x = this._mouseStart.pdfX < this._mouseEnd.pdfX ? this._mouseStart.pdfX : this._mouseEnd.pdfX;
                newElement.y = this._mouseStart.pdfY < this._mouseEnd.pdfY ? this._mouseStart.pdfY : this._mouseEnd.pdfY;
                newElement.width = this._mouseStart.pdfX < this._mouseEnd.pdfX ? this._mouseEnd.pdfX - this._mouseStart.pdfX : this._mouseStart.pdfX - this._mouseEnd.pdfX;
                newElement.height = this._mouseStart.pdfY < this._mouseEnd.pdfY ? this._mouseEnd.pdfY - this._mouseStart.pdfY : this._mouseStart.pdfY - this._mouseEnd.pdfY;
                newElement.pageNumber = this._mouseStartPage.pageNumber;
                
                if (typeof this.defaultFont.fontSize !== 'undefined' && this.defaultFont.fontSize !== null && isFinite(this.defaultFont.fontSize)) {
                    newElement.fontSize = this.defaultFont.fontSize;
                }
                if (typeof this.defaultFont.fontName !== 'undefined' && this.defaultFont.fontName !== null && this.defaultFont.fontName !== '') {
                    newElement.fontName = this.defaultFont.fontName;
                }
                if (typeof this.defaultFont.fontColour !== 'undefined' && this.defaultFont.fontColour !== null && this.defaultFont.fontColour !== '') {
                    newElement.fontColour = this.defaultFont.fontColour;
                }
                if (typeof this.defaultFont.fontBold !== 'undefined' && this.defaultFont.fontBold !== null) {
                    newElement.fontBold = this.defaultFont.fontBold;
                }
                if (typeof this.defaultFont.fontItalic !== 'undefined' && this.defaultFont.fontItalic !== null) {
                    newElement.fontItalic = this.defaultFont.fontItalic;
                }

                this.onAddPdfElement(newElement);
            }
        }
    };

    AddTextMode.prototype.onMouseMove = function (mouseEvent, page) {
        if (this._mouseIsDown === true) {
            this._mouseEnd = coordinates.Position.fromMouseEvent(mouseEvent, this._mouseStartPage.pageViewport, this._mouseStartPage.pdfOverlayCanvasElement);
            this._mouseEndPage = page;
        }
    };

    AddTextMode.prototype.renderToCanvas = function (page) {
        BoxDrawMode.prototype.renderToCanvas.call(this, page, AddTextMode.colourSettings);

        if (this._mouseStart !== null && this._mouseEnd !== null) {
            var fontSize = 10;
            if (typeof this.defaultFont.fontSize !== 'undefined' && this.defaultFont.fontSize !== null && isFinite(this.defaultFont.fontSize)) {
                fontSize = this.defaultFont.fontSize;
            }

            var elementRectangle = coordinates.Rectangle.fromPositions(this._mouseStart, this._mouseEnd, page.pageViewport);
            multiLineTextboxRender(fontSize, elementRectangle, page.pageViewport.scale, page.pdfOverlayCanvasContext);
        }
    };

    return AddTextMode;
})();

module.exports = AddTextMode;

var coordinates = require('../Coordinates');
var PdfTextElement = require('../Elements/pdf-text-element.js');
var multiLineTextboxRender = require('../pdf-multi-line-textbox-render.js');